import React from 'react';
import {
  AvatarGroup,
  Box,
  HStack,
  StackProps,
  Text,
} from '@cardboard-ui/react';
import { graphql, useFragment } from 'utils/graphClient';
import { notEmpty } from 'utils/NotEmptyFilter';
import { UserAvatar } from 'components/UserAvatar';
import { VaultManagementGroupLabel_vaultManagementGroup$key } from './__generated__/VaultManagementGroupLabel_vaultManagementGroup.graphql';
import { t } from '@lingui/macro';

const vaultManagementGroupFragment = graphql`
  fragment VaultManagementGroupLabel_vaultManagementGroup on VaultManagementGroup {
    id
    name
    managers {
      edges {
        node {
          id
          ...UserAvatar_member
        }
      }
    }
  }
`;

type VaultManagementGroupLabelProps = StackProps & {
  vaultManagementGroup: VaultManagementGroupLabel_vaultManagementGroup$key;
  isEmpty?: boolean;
  isSearching?: boolean;
};

export const VaultManagementGroupLabel = ({
  vaultManagementGroup,
  isEmpty,
  isSearching,
  ...stackProps
}: VaultManagementGroupLabelProps) => {
  const { name, managers } = useFragment(
    vaultManagementGroupFragment,
    vaultManagementGroup,
  );

  return (
    <HStack {...stackProps}>
      <AvatarGroup size="xs" max={2} spacing={-2}>
        {managers.edges
          .map(({ node }) => node)
          .filter(notEmpty)
          .map((member) => (
            <UserAvatar member={member} key={member.id} />
          ))}
      </AvatarGroup>

      <Text>
        {name}
        {isEmpty && (
          <Box marginInline={1} display="inline-block">
            {isSearching ? t`(No search results)` : t`(No vaults)`}
          </Box>
        )}
      </Text>
    </HStack>
  );
};
